import { forwardRef, type SVGProps } from 'react';

export const ShipFromIconLight = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(function ShipFromIconLight(props, ref) {
  return (
    <svg
      ref={ref}
      fill="none"
      viewBox="0 0 37 25"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M31 5.0625L19.15 5.0625C18.7 5.0625 18.3156 5.22188 17.9969 5.54063C17.6781 5.85938 17.5188 6.24375 17.5188 6.69375V18.8719H19.1219C19.1219 19.7344 19.4266 20.4703 20.0359 21.0797C20.6453 21.6891 21.3813 21.9937 22.2438 21.9937C23.1063 21.9937 23.8422 21.6891 24.4516 21.0797C25.0609 20.4703 25.3656 19.7344 25.3656 18.8719H31V17.5781H25.0844C24.8406 17.0531 24.4563 16.6125 23.9313 16.2562C23.4063 15.9 22.8438 15.7219 22.2438 15.7219C21.6063 15.7219 21.0344 15.9 20.5281 16.2562C20.0219 16.6125 19.6469 17.0531 19.4031 17.5781H18.7844V6.69375C18.7844 6.6 18.8219 6.51562 18.8969 6.44062C18.9719 6.36562 19.0563 6.32812 19.15 6.32812H31V5.0625ZM23.5656 20.1656C23.2094 20.5219 22.7688 20.7 22.2438 20.7C21.7375 20.7 21.3063 20.5219 20.95 20.1656C20.5938 19.8094 20.4156 19.3781 20.4156 18.8719C20.4156 18.3656 20.5938 17.9297 20.95 17.5641C21.3063 17.1984 21.7375 17.0156 22.2438 17.0156C22.7688 17.0156 23.2094 17.1984 23.5656 17.5641C23.9219 17.9297 24.1 18.3656 24.1 18.8719C24.1 19.3781 23.9219 19.8094 23.5656 20.1656Z"
        fill="#0C3260"
        fillRule="evenodd"
      />
      <path d="M6 18L12 12L6 6V18Z" fill="#0C3260" />
    </svg>
  );
});
